import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import useUserRoles from 'utils/hooks/auth/useUserRoles';
import {
  setSubmissionsListCurrentPage,
  setSubmissionsListPageSize,
} from 'store/entities/submissions';

import ListItem from './ListItem';
import { Pagination } from 'components/UIComponents/Table';

import './style.scss';
import { Row } from './../../../components/UIComponents/Layout/Row/index';
import { Column } from './../../../components/UIComponents/Layout/Column/index';
import { Heading } from './../../../components/UIComponents/Typography/Heading/index';
import {isValidSearchInput} from "../../../utils/stringUtils";

const List = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isBlackBoxUploader } = useUserRoles();

  const {
    submissionsList,
    submissionsListLoading,
    submissionsListCurrentPage,
    submissionsListPageSize,
    submissionsListTotalPages,
    submissionsListTotalElements,
    obligation
  } = useSelector(state => state.submissions);

  const isPaginationDisabled = submissionsListLoading || submissionsListTotalElements === 0 || !isValidSearchInput(obligation);

  return (
    <>
      {isBlackBoxUploader && (
        <ListItem data={{ status: 'bb' }} key="obligation_bb" />
      )}
      {submissionsList.map(item => (
        <ListItem data={item} key={`obligation_${item.id}`} />
      ))}
      {submissionsList.length > 0 ? (
        <Pagination
          disabled={isPaginationDisabled}
          currentPage={submissionsListCurrentPage + 1}
          totalPages={submissionsListTotalPages}
          totalRecords={submissionsListTotalElements}
          pageSize={submissionsListPageSize}
          delta={2}
          className="is-small mt-2"
          onPageChange={newPage => {
            dispatch(setSubmissionsListCurrentPage(newPage - 1));
          }}
          onPageSizeChange={newSize =>
            dispatch(setSubmissionsListPageSize(newSize))
          }
          recordsPerPageText={t(
            'datagate.external.global.table.pagination.recordsPerPage'
          )}
          recordsText={t('datagate.external.global.table.pagination.records')}
          pageText={t('datagate.external.global.table.pagination.page')}
        />
      ) : (
        <Row className="empty-list">
          <Column className="center-content">
            <Heading subtitle className="fw-bold">
              {t('datagate.external.submissions.message.noObligations')}
            </Heading>
          </Column>
        </Row>
      )}
    </>
  );
};

export default List;
